module.exports = __webpack_public_path__ + "static/media/1.aab2e311.jpg";